<template>
<div id="app">
  <b-navbar toggleable="md" type="dark">
    <b-navbar-brand>
      <img src='./assets/navantia_logo.png'>
      <div class="navbar-brand-text">{{ $t("commons.tagWan") }}</div>
    </b-navbar-brand>
    <b-navbar-nav>
      <b-nav-item to="/" exact>{{ $t("navbar.realTime") }}</b-nav-item>
    </b-navbar-nav>

    <!-- <b-navbar-nav class="ml-auto">

      <b-nav-item-dropdown text="Lang" right>
        <b-dropdown-item href="#">EN</b-dropdown-item>
        <b-dropdown-item href="#">ES</b-dropdown-item>
        <b-dropdown-item href="#">GL</b-dropdown-item>
      </b-nav-item-dropdown>

      <b-nav-item-dropdown right>
         Using button-content slot
        <template slot="button-content">
          {{ $t("navbar.user") }}
        </template>
        <b-dropdown-item href="#">{{ $t("navbar.logOut") }}</b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav> -->
  </b-navbar>
  <router-view></router-view>
</div>

</template>

<script>

export default {
  name: 'app',
  components: {
  },
};
</script>

<style>

html, body {
  height: 100%;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 98%;
  margin: auto;
}

.navbar{
    background-color: #003366;
}

.navbar-brand-text {
  display: inline-block !important;
}

.navbar-brand>img{
    height: 30px;
    width: auto;
    margin-bottom: 5px;
}
</style>
